import { render } from "./g-admin-editor.vue?vue&type=template&id=ea542374&ts=true"
import script from "./g-admin-editor.vue?vue&type=script&lang=tsx"
export * from "./g-admin-editor.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__